// Tracks whether the service worker has finished precaching all build assets.
// Until this is true, going offline may result in missing JS chunks.

let ready = false;
let pollTimer = null;
const listeners = new Set();

const notifyListeners = () => {
  listeners.forEach((cb) => {
    try {
      cb(ready);
    } catch (e) {
      // listener errors shouldn't break the chain
    }
  });
};

const isReady = () => ready;

const setReady = (value) => {
  const next = value === true;
  if (next === ready) return;
  ready = next;
  if (next && pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
  notifyListeners();
};

const subscribe = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

// The SW is truly ready when:
// - registration.active exists (an SW is running)
// - registration.installing is null (no new SW is being installed / precaching)
// - registration.waiting is null (no SW stuck waiting to activate)
// This handles the post-deploy case where the old SW is active but the new
// one is still installing with fresh chunk hashes.
const checkRegistration = async () => {
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (reg?.active && !reg.installing && !reg.waiting) {
      setReady(true);
      return true;
    }
  } catch (e) {
    // ignore
  }
  return false;
};

if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  // Check immediately, then poll every second until ready.
  checkRegistration().then((done) => {
    if (!done) {
      pollTimer = setInterval(() => checkRegistration(), 1000);
    }
  });
} else {
  // No SW support (old browser, dev mode) — nothing to wait for.
  ready = true;
}

export default { isReady, setReady, subscribe };
